import React from 'react';
import './App.css';

const ExportModal = ({ isOpen, onClose, onExport, currentModel }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Export Options</h2>
                <button onClick={() => onExport('all')}>Export All MELs</button>
                <button onClick={() => onExport('current')}>Export {currentModel} MEL</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
};

export default ExportModal;